import AxiosConfig from '@/config/axios-config'

export const DestaquesAPI = {

  listarDestaquesHome () {
    return AxiosConfig.secureJalekoAPI().get('/destaques').then(response => response.data)
  }

}

export default DestaquesAPI
